import { WageActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { WageFormData } from 'src/screens/General/screens/Wages/components/WageForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetWagesAction {
    type: typeof WageActions.FETCH_WAGES;
    payload: QueryParams;
}

export function getWages(params: QueryParams): GetWagesAction {
    return {
        type: WageActions.FETCH_WAGES,
        payload: params,
    };
}

export interface GetWageAction {
    type: typeof WageActions.FETCH_WAGE;
    payload: {
        id: string | number;
    };
}

export function getWage(id: string | number): GetWageAction {
    return {
        type: WageActions.FETCH_WAGE,
        payload: { id },
    };
}

export interface DeleteWageAction {
    type: typeof WageActions.DELETE_WAGE;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteWage(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteWageAction {
    return {
        type: WageActions.DELETE_WAGE,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistWageAction {
    type: typeof WageActions.PERSIST_WAGE;
    payload: {
        data: WageFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistWage(data: WageFormData, callbacks: SagaPromise<any>): PersistWageAction {
    return {
        type: WageActions.PERSIST_WAGE,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistWage = (data: WageFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistWage(data, { resolve, reject }));
    });
};

export type Actions = GetWagesAction | GetWageAction | DeleteWageAction | PersistWageAction;
